export default "__VITE_ASSET__46bc5825__"